import BRAND_LOGO from '../../themes/pulse/brand_logo_home.gif';

const pulse = {
  application: 'Pulse',
  business: 'Pulse Corp',
  fullBusiness: 'Pulse Corporation',
  hmLink: 'https://pulse.example.com',
  businessLink: 'https://pulse.example.com',
  contactEmail: 'support@pulse.example.com',
  contactEmailSupport: 'support@pulse.example.com',
  brandLogo: '/themes/pulse/logo.png',
  BRAND_LOGO: BRAND_LOGO
};

export default pulse;
